import { render, staticRenderFns } from "./zsbIndex.vue?vue&type=template&id=49f9a850&scoped=true"
import script from "./zsbIndex.vue?vue&type=script&lang=js"
export * from "./zsbIndex.vue?vue&type=script&lang=js"
import style0 from "./zsbIndex.vue?vue&type=style&index=0&id=49f9a850&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f9a850",
  null
  
)

export default component.exports